/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import t from "prop-types";
import { useUnstyled as d, classNames as c, uHint as l } from "@progress/kendo-react-common";
const n = (r) => {
  const e = {
    direction: "start",
    ...r
  }, s = d(), i = s && s.uHint, a = o.useMemo(
    () => c(
      l.wrapper({
        c: i,
        direction: e.direction,
        disabled: e.editorDisabled === !0
      }),
      e.className
    ),
    [i, e.direction, e.editorDisabled, e.className]
  );
  return /* @__PURE__ */ o.createElement("div", { id: e.id, style: e.style, className: a }, e.children);
};
n.propTypes = {
  id: t.string,
  direction: t.oneOf(["start", "end"]),
  children: t.oneOfType([t.element, t.node]),
  style: t.object,
  className: t.string,
  editorDisabled: t.bool
};
n.displayName = "KendoReactHint";
export {
  n as Hint
};
